var map = {
	"./bg-BG.json": 647,
	"./ca-ES.json": 2618,
	"./cs-CZ.json": 2410,
	"./de-DE.json": 2303,
	"./el-GR.json": 3149,
	"./en-US.json": 4771,
	"./es-ES.json": 6714,
	"./et-EE.json": 8728,
	"./fi-FI.json": 156,
	"./fr-FR.json": 8729,
	"./he-IL.json": 3041,
	"./it-IT.json": 3279,
	"./ja-JP.json": 6208,
	"./ko-KR.json": 4791,
	"./nb-NO.json": 2314,
	"./nl-NL.json": 3434,
	"./nn-NO.json": 4030,
	"./pl-PL.json": 7070,
	"./pt-BR.json": 6917,
	"./ro-RO.json": 9275,
	"./ru-RU.json": 6222,
	"./sk-SK.json": 4574,
	"./sv-SE.json": 9014,
	"./tr-TR.json": 1888,
	"./zh-CN.json": 8557
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5061;